var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Header',{attrs:{"isFiexd":_vm.isFiexd}}),_c('router-view'),_c('Bottom'),_c('el-backtop',{attrs:{"target":".nav"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }